<template>
  <v-layout justify-center>
    <v-card width="80%" height="300px">
      <v-card-title> Process items </v-card-title>
      <v-divider></v-divider>
      <v-row class="py-16" justify="center">
        <v-col cols="6" lg="4" md="6" sm="10">
          <v-text-field
            label="Enter SKU"
            color="primary"
            v-model="SKU"
            @keypress.enter="search"
            ref="SKU"
          >
            <template v-slot:append>
              <v-btn
                depressed
                tile
                color="primary"
                class="ma-0"
                @click="search"
                :disabled="SKU === ''"
              >
                Search
              </v-btn>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </v-card>
  </v-layout>
</template>

<script>
export default {
  name: "SearchSKU",
  props: {},
  data: () => ({
    SKU: "",
  }),
  methods: {
    reset() {
      this.$emit("close");
    },
    search() {
      this.$emit("search", this.SKU.trim());
    },
  },
};
</script>